export const niveis = [
  { value: 1, label: 'A1 - Iniciante', cor: '255, 89, 89' },
  { value: 2, label: 'A2 - Basico', cor: '255, 145, 89' },
  { value: 3, label: 'B1 - Intermediário', cor: '243, 183, 33' },
  { value: 4, label: 'B2 - Interm. Avançado', cor: '128, 204, 20' },
  { value: 5, label: 'C1 - Avançado', cor: '37, 184, 105' },
  { value: 6, label: 'C2 - Proficiente', cor: '10, 95, 85' },
];
